export async function makeArbiterRequest(url: string, requestParams?: Record<string, unknown>) {
    const body = requestParams && JSON.stringify(requestParams);

    return fetch(url, {
        body,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
    })
        .then((response) => {
            if (response.status === 200 || response.status === 418) {
                return response.json().then((data) => ({ status: response.status, data }));
            }

            return { status: response.status, data: undefined };
        })
        .catch((error) => ({ status: error.status, data: error }));
}
